import { render, staticRenderFns } from "./OrganizationCreateStaffInfo.vue?vue&type=template&id=67df0ea3&"
import script from "./OrganizationCreateStaffInfo.vue?vue&type=script&lang=ts&"
export * from "./OrganizationCreateStaffInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports